"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pianoro": {
    "79406a09": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "skipSearch": false
    }],
    "gorgognano": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1053083": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "skipSearch": false
    }],
    "monte-delle-formiche": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75c79dc1": [{
      "hkey": "c7401623",
      "slug": "musiano-pian-di-macina",
      "name": "Musiano-Pian di Macina",
      "primary": true,
      "skipSearch": false
    }],
    "musiano": [{
      "hkey": "c7401623",
      "slug": "musiano-pian-di-macina",
      "name": "Musiano-Pian di Macina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5e16a1cc": [{
      "hkey": "c7401623",
      "slug": "musiano-pian-di-macina",
      "name": "Musiano-Pian di Macina",
      "primary": true,
      "skipSearch": false
    }],
    "pian-di-macina": [{
      "hkey": "c7401623",
      "slug": "musiano-pian-di-macina",
      "name": "Musiano-Pian di Macina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pianoro"
    }],
    "408b1fcb": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "skipSearch": false
    }],
    "riosto": [{
      "hkey": "04b018b0",
      "slug": "pianoro",
      "name": "Pianoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33f13a4c": [{
      "hkey": "ce84ac89",
      "slug": "botteghino-di-zocca",
      "name": "Botteghino di Zocca",
      "primary": true,
      "skipSearch": false
    }],
    "san-salvatore-di-casola": [{
      "hkey": "ce84ac89",
      "slug": "botteghino-di-zocca",
      "name": "Botteghino di Zocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;